<template>
  <div class="register-page">
    <van-nav-bar
      title="用户注册"
      left-arrow
      @click-left="goHome"
      fixed
    />

    <div class="content">
      <div class="form-container">
        <van-notice-bar
          type="warning"
          wrapable
          class="notice-bar"
        >
          账号密码不限制，但请牢记！！！
        </van-notice-bar>

        <van-field
          v-model="userName"
          label="用户名"
          placeholder="6-30 位，中文/字母/数字"
          clearable
          :error-message="userNameError"
        />

        <van-field
          v-model="passWord"
          type="password"
          label="密码"
          placeholder="6-18 位，字母或数字"
          clearable
          :error-message="passWordError"
        />

        <van-button
          type="primary"
          block
          round
          class="submit-btn"
          @click="handleRegister"
        >
          立即注册
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { userRegister } from '../utils/api';

export default {
  name: 'Register',
  data() {
    return {
      userName: '',
      passWord: '',
      userNameError: '',
      passWordError: ''
    };
  },
  methods: {
    validate() {
      this.userNameError = '';
      this.passWordError = '';
      
      let valid = true;
      
      if (!this.userName.trim()) {
        this.userNameError = '用户名不能为空';
        valid = false;
      } else if (this.userName.length < 6 || this.userName.length > 30) {
        this.userNameError = '用户名长度 6-30 位';
        valid = false;
      }
      
      if (!this.passWord) {
        this.passWordError = '密码不能为空';
        valid = false;
      } else if (this.passWord.length < 6 || this.passWord.length > 18) {
        this.passWordError = '密码长度 6-18 位';
        valid = false;
      } else if (!/^[a-zA-Z0-9]+$/.test(this.passWord)) {
        this.passWordError = '密码只能是字母或数字';
        valid = false;
      }
      
      return valid;
    },
    async handleRegister() {
      if (!this.validate()) {
        return;
      }

      try {
        const res = await userRegister({
          userName: this.userName.trim(),
          passWord: this.passWord
        });

        if (res && res.code === 200) {
          this.$toast.success('注册成功');
          
          setTimeout(() => {
            this.$router.push({
              path: '/login',
              query: {
                userName: this.userName,
                passWord: this.passWord
              }
            });
          }, 500);
        }
      } catch (error) {
        console.error('Register error:', error);
        if (error.response && error.response.data && error.response.data.msg) {
          this.$toast(error.response.data.msg);
        } else {
          this.$toast('注册失败');
        }
      }
    },
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
  padding-bottom: 50px;
}

.content {
  padding: 40px 16px;
}

.form-container {
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.notice-bar {
  margin-bottom: 24px;
  border-radius: 8px;
}

.submit-btn {
  margin-top: 32px;
  height: 48px;
  font-size: 16px;
}
</style>
